var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.666 7.5V2.5L18.3327 10L11.666 17.5V12.5C7.03268 12.5 3.98268 14.1917 1.66602 17.5C2.59102 12.775 5.18268 8.44167 11.666 7.5Z","fill":"currentColor"}));
}

Share.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Share;

Share.default = Share;
